<script setup lang="ts">
import { ref } from 'vue';
import UiChevron from '@/views/CRM/components/UiChevron.vue';

interface Props {
  duplicates: any[];
  hasPermission?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  hasPermission: () => false,
});

const isPopoverShow = ref(false);
</script>

<template>
  <ElPopover
    v-if="props.hasPermission && props.duplicates.length > 1"
    placement="bottom"
    trigger="click"
    width="auto"
    popper-class="payment-duplicates__popover"
    @update:visible="isPopoverShow = $event"
  >
    <template v-slot:reference>
      <div class="payment-duplicates">
        <UiIcon
          name="exclamation-circle"
          color="inherit"
        />
        {{ $t('mediaBuying.info.post_info_card.possible_duplicates') }}
        <UiChevron :rotate="!isPopoverShow" />
      </div>
    </template>
    <div
      v-for="(duplicate, i) in props.duplicates"
      :key="i"
      class="payment-duplicates__item"
    >
      <RouterLink
        class="payment-duplicates__item_link"
        :to="`/affiliates/${duplicate.affiliate_id}/info`"
      >
        {{ duplicate.affiliate_email }}
      </RouterLink>
      <UiSeparator type="dot" />
      {{ duplicate.campaign_name }} (ID {{ duplicate.campaign_incrementing_id }})
    </div>
  </ElPopover>
  <div
    v-else
    class="payment-duplicates"
  >
    <UiIcon
      name="exclamation-circle"
      color="inherit"
    />
    {{ $t('mediaBuying.info.post_info_card.possible_duplicates') }}
  </div>
</template>

<style lang="scss">
.payment-duplicates {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-negative);
  padding: 2px 8px;
  font-size: 12px;
  line-height: 18px;
  border-radius: 5px;
  background: var(--background-negative-subtle);
  cursor: pointer;


  &__popover.el-popover.el-popper {
    display: flex;
    flex-direction: column;
    padding: 16px;;
    gap: 8px;
    border-radius: 8px;
    background: var(--background-body);
    box-shadow: 0 4px 32px 0 rgba(0, 0, 0, 0.16);
  }
  &__item {
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--text-body-secondary);
    font-size: 14px;
    line-height: 18px;
    &_link {
      color: var(--text-link);
    }
  }
}
</style>
